<template>
    <v-app
        :dark="darkMode"
        id="inspire"
        :class="[{
            'box-layout': boxLayout,
            'collapse-sidebar': collapseSidebar,
            'rtl-layout': rtlLayout
        }, envClass]"
    >
        <router-view></router-view>
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            envClass: ''
        }
    },
    created () {
        this.envClass = this.getEnvClass()
    },
    mounted () {
        // if (
        //     this.selectedLocale.locale === 'he' ||
        //     this.selectedLocale.locale === 'ar'
        // ) {
        //     this.$store.dispatch('rtlLayout')
        // }
    },
    computed: {
        ...mapGetters([
            'darkMode',
            'collapseSidebar',
            'boxLayout',
            'rtlLayout',
            'selectedLocale'
        ])
    },
    methods: {
        getEnvClass () {
            const hostname = (window.location && window.location.hostname
                ? window.location.hostname
                : '').toLowerCase()

            if (
                hostname === 'localhost' ||
                hostname === '127.0.0.1' ||
                hostname === 'coronertest.gannettpeaktech.com'
            ) {
                return 'env-devtest'
            }

            return ''
        }
    }
}
</script>
